var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPackagePlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 122,
    viewBox: "0 0 126 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 121.478C97.5178 121.478 125.5 94.2841 125.5 60.7389C125.5 27.1937 97.5178 0 63 0C28.4822 0 0.5 27.1937 0.5 60.7389C0.5 94.2841 28.4822 121.478 63 121.478Z",
    fill: "#EDEBF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0072 36.091H51.3573C48.98 36.091 47.0529 37.9638 47.0529 40.2741V40.2741C47.0529 42.5844 48.98 44.4572 51.3573 44.4572H83.0072C85.3844 44.4572 87.3116 42.5844 87.3116 40.2741C87.3116 37.9638 85.3844 36.091 83.0072 36.091Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9114 52.8235H103.453C105.831 52.8235 107.758 54.6963 107.758 57.0066C107.758 59.3169 105.831 61.1898 103.453 61.1898H30.9114C28.5341 61.1898 26.6069 59.3169 26.6069 57.0066C26.6069 54.6963 28.5341 52.8235 30.9114 52.8235V52.8235Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9114 69.5561H103.453C105.831 69.5561 107.758 71.4289 107.758 73.7392C107.758 76.0495 105.831 77.9223 103.453 77.9223H30.9114C28.5341 77.9223 26.6069 76.0495 26.6069 73.7392C26.6069 71.4289 28.5341 69.5561 30.9114 69.5561V69.5561Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6805 59.793C40.6309 59.7946 40.5812 59.7956 40.5316 59.7969C40.5104 59.8505 40.4875 59.9037 40.4611 59.9558L40.6805 59.793V59.793Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.753 64.5303C113.978 38.3949 93.9816 15.4545 67.0885 13.2915C40.1954 11.1285 16.5899 30.5619 14.3642 56.6972C12.1384 82.8326 32.1353 105.773 59.0284 107.936C85.9215 110.099 109.527 90.6656 111.753 64.5303Z",
    fill: "#6C63FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0495 49.0906L62.315 37.6969L42.5804 49.0906V71.8781L62.315 83.2719M82.0495 49.0906L62.315 61.9086M82.0495 49.0906V60.4844M62.315 83.2719V61.9086M62.315 83.2719L66.5863 80.8058M62.315 61.9086L43.8001 50.5148M70.8603 54.7875L52.3455 43.3938M71.57 74.0144H77.9798M77.9798 74.0144H84.3879M77.9798 74.0144L77.9798 67.6054M77.9798 74.0144V80.4234",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackagePlus);
export default __webpack_public_path__ + "static/media/packagePlus.39fc451a37a262c9aecec423d3997050.svg";
export { ForwardRef as ReactComponent };